import React  from "react";
const HowOftenExceedCredit = ({
    onSelectAnswer,
    backClick
}) => {
    const optionClicked = async (e) => {
        onSelectAnswer(e);
    };

    return (
        <>
            <div className="question-content mt-0 scale-down-ver-center px-3 py-lg-3 py-md-3 py-sm-2 py-2 ">
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="257"
                                name="oftenexceedCredit"
                                id="nextscrolla"
                                data-quest-id={96}
                                data-ans-id={257}
                                data-ans-label={"Always"}
                            >Always
                            </button>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="258"
                                name="oftenexceedCredit"
                                id="nextscrolla"
                                data-quest-id={96}
                                data-ans-id={258}
                                data-ans-label={"Sometimes"}
                            >Sometimes
                            </button>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="259"
                                name="oftenexceedCredit"
                                id="nextscrolla"
                                data-quest-id={96}
                                data-ans-id={259}
                                data-ans-label={"Rarely"}
                            >Rarely
                            </button>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="260"
                                name="oftenexceedCredit"
                                id="nextscrolla"
                                data-quest-id={96}
                                data-ans-id={260}
                                data-ans-label={"Never"}
                            >Never
                            </button>
                        </div>
                    </div>
                </div>
                <p className="text-center bck-marwid">
                    <button
                        name="exceedCredLimit"
                        className="btn btn-secondary backbtn1a"
                        id=""
                        value=""
                        type="button"
                        onClick={backClick}

                    >Go Back</button>
                </p>
            </div>
        </>
    )
}
export default HowOftenExceedCredit; 